import LegalPage from "@/components/LegalPage";
import { Link } from "react-router-dom";

/**
 * /cancellation-form — Muster-Widerrufsformular.
 *
 * ⚠️ NON-PUBLIC NOTICE:
 * Legal pages contain placeholders and must not be considered final until
 * operator data is inserted and reviewed.
 */
export default function CancellationForm() {
  return (
    <LegalPage
      title="Muster-Widerrufsformular"
      subtitle="Wenn Sie den Vertrag widerrufen wollen, können Sie dieses Formular ausfüllen und an uns senden."
      updatedAt="05.07.2026"
    >
      <div className="bg-[#12141C] border border-[#1E212B] rounded-lg p-6 sm:p-8 space-y-5 text-sm">
        <div>
          <p className="text-[10px] font-mono uppercase tracking-wider text-zinc-500 mb-1">
            An
          </p>
          <address className="not-italic text-zinc-200">
            Gökhan Tan<br />
            Jägerhofallee 34<br />
            71638 Ludwigsburg<br />
            Deutschland<br />
            E-Mail: pineforgeai@gmx.de
          </address>
        </div>

        <FormLine
          label="Hiermit widerrufe(n) ich/wir den von mir/uns abgeschlossenen Vertrag über die Nutzung von PineForge.AI"
          rows={2}
        />

        <FormLine label="Bestellt am" />

        <FormLine label="Name des/der Verbraucher(s)" />

        <FormLine label="Anschrift des/der Verbraucher(s)" rows={2} />

        <FormLine label="E-Mail-Adresse des Nutzerkontos" />

        <FormLine label="Datum" />

        <div>
          <p className="text-[10px] font-mono uppercase tracking-wider text-zinc-500 mb-1">
            Unterschrift des/der Verbraucher(s)
          </p>
          <div className="h-8 border-b border-dashed border-[#2D313F]" />
          <p className="mt-1 text-[11px] text-zinc-500">
            (nur bei Mitteilung auf Papier)
          </p>
        </div>
      </div>

      <p className="text-zinc-500 text-xs">
        Zurück zur{" "}
        <Link
          to="/cancellation"
          className="text-blue-400 hover:text-blue-300 underline underline-offset-2"
        >
          Widerrufsbelehrung
        </Link>
        .
      </p>
    </LegalPage>
  );
}

function FormLine({ label, rows = 1 }) {
  return (
    <div>
      <p className="text-[10px] font-mono uppercase tracking-wider text-zinc-500 mb-1">
        {label}
      </p>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-8 border-b border-dashed border-[#2D313F]" />
      ))}
    </div>
  );
}
